// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Controller } from 'app/scripts/controller';
import BoardDisplayHelpers from 'app/scripts/views/internal/board-display-helpers';
import permsTemplate from 'app/scripts/views/templates/board_header_permissions';
import { l } from 'app/scripts/lib/localize';
import { Auth } from 'app/scripts/db/auth';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { Analytics } from '@trello/atlassian-analytics';
import { ChangeBoardVisibilityView } from 'app/scripts/views/board-menu/ChangeBoardVisibilityView';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { BoardAddToOrganizationView } from 'app/scripts/views/board-menu/BoardAddToOrganizationView';

export const permChange = function (newPerm) {
  if (newPerm === 'none') {
    Controller.memberHomePage();
  } else {
    this.render();
    // If we can't edit the board, hide the card composer (if it's open)
    if (!this.model.editable()) {
      this.model.composer.save('vis', false);
    }
  }
};

export const renderPermissionLevel = function () {
  const $perm = this.$('#permission-level');
  const data = {
    permIconClass: BoardDisplayHelpers.getPermLevelIconClassForBoard(
      this.model,
    ),
    permText: l(['board perms', this.model.getPermLevel(), 'name']),
  };

  $perm.html(permsTemplate(data));

  if (this.model.isTemplate()) {
    $perm.attr(
      'title',
      BoardDisplayHelpers.getPermLevelAltTextForTemplate(this.model),
    );
  } else {
    $perm.attr(
      'title',
      BoardDisplayHelpers.getPermLevelAltTextForBoard(this.model),
    );
  }

  const canInvite = this.model.canInvite(Auth.me());
  this.$('.js-manage-board-members').toggle(canInvite);

  return this;
};

export const changeVis = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'changeBoardVisibilityButton',
    source: 'boardScreen',
  });

  PopOver.toggle({
    elem: this.$('.js-change-vis'),
    view: ChangeBoardVisibilityView,
    options: { model: this.model, modelCache: this.modelCache },
  });
};

export const addBoardToTeam = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'changeBoardWorkspaceButton',
    source: 'boardScreen',
  });

  return PopOver.toggle({
    elem: this.$('.js-add-board-to-team'),
    view: BoardAddToOrganizationView,
    options: { model: this.model, modelCache: this.modelCache },
  });
};
